import React from "react";
import { RouteComponentProps } from "react-router-dom";
import { Devices, PairScreen, Schedules, ScreenEdit } from "./components";
import { ScreenInterface, ApiHelper, UserHelper } from "../helpers"
import { Row, Col } from "react-bootstrap"
import { v4 } from 'uuid';


type TParams = { id?: string };

interface Props {
  refreshSidebar: () => void,
  routeData: RouteComponentProps<TParams>
}


export const ScreenPage = (props: Props) => {

  const [screen, setScreen] = React.useState<ScreenInterface>(null);
  const [showPair, setShowPair] = React.useState(false);

  const init = () => {
    setShowPair(false);
    if (props.routeData.match.params.id === "0") createScreen();
    else ApiHelper.get("/screens/" + props.routeData.match.params.id).then((data) => { setScreen(data); });
  }

  const createScreen = () => {
    const guid = v4().replaceAll("-", "");
    ApiHelper.get("/users/" + UserHelper.user.id).then(u => {
      setScreen({ id: 0, screenMode: "digitalsignage", name: "", timezone: u.timezone, guid: guid });
    });
  }

  const getRightSide = () => {
    const result: JSX.Element[] = [];
    if (screen) {
      console.log("sceen id")
      console.log(screen.id)
      if (showPair) result.push(<PairScreen key="pairScreen" screen={screen} />)
      if ((screen.screenMode === "digitalsignage" || screen.screenMode === "both") && screen.id > 0) result.push(<Schedules key="schedules" screen={screen} />);
    }
    return result;
  }


  React.useEffect(init, [props.routeData.match.params])

  return (
    <>
      <h1><i className="fas fa-tv"></i> Screens</h1>
      <Row>
        <Col md={6}>
          <ScreenEdit screen={screen} refreshSidebar={props.refreshSidebar} onUpdate={setScreen} showPair={() => { setShowPair(true); }} />
          <Devices screen={screen} />
        </Col>
        <Col md={6}>
          {getRightSide()}
        </Col>
      </Row>
    </>
  )


};